<template>
  <div id="senior-member-report-page">
    <v-overlay :value="LoadingFlag === true" z-index="999">
      <v-progress-circular indeterminate size="64" color="white"></v-progress-circular>
    </v-overlay>

    <!-- Premium Header Card with EfficiencyLomStatus-Style Animation -->
    <v-card elevation="20" class="header-card mb-6 overflow-hidden">
      <div class="header-gradient">
        <div class="header-backdrop-effect"></div>
        <div class="header-content pa-8">
          <v-row align="center" justify="space-between">
            <!-- Left Side: Title and Icon -->
            <v-col cols="12" md="8" class="d-flex align-center">
              <div class="header-icon-box">
                <v-icon size="40px" color="white">mdi-account-multiple</v-icon>
              </div>
              <div class="ml-4">
                <h1 class="header-title white--text mb-0">{{ PageTitle }}</h1>
                <p class="header-subtitle white--text mb-0">{{ PageDescription }}</p>
              </div>
            </v-col>

            <!-- Right Side: Action Buttons -->
            <v-col cols="12" md="4" class="text-right">
              <v-btn icon class="action-btn mr-2" @click="searchForm" :loading="SearchFlag" title="Refresh">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn icon class="action-btn" @click="backPage" title="Close">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>

    <!-- Filter Section -->
    <v-card elevation="8" class="filter-card mb-6">
      <v-card-text class="pa-6">
        <v-form ref="form2" v-model="valid1" lazy-validation id="createForm">
          <v-row wrap>
            <v-col cols="12" md="3">
              <div class="filter-label-wrapper">
                <v-icon small color="primary" class="mr-1">mdi-calendar</v-icon>
                <label class="filter-label"><span class="text-danger">*</span> Year</label>
              </div>
              <v-autocomplete :reduce="(option) => option.value" :items="JciYearCodeOptions" :rules="JciYearCodeRules"
                v-model="JciYearCode" dense clearable required outlined class="modern-input"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" v-if="AreaFlag">
              <div class="filter-label-wrapper">
                <v-icon small color="primary" class="mr-1">mdi-map</v-icon>
                <label class="filter-label"><span class="text-danger">*</span> Area</label>
              </div>
              <v-autocomplete @change="getZoneCodeOptions" :reduce="(option) => option.value"
                :loading="AreaCodeOptionsLoading" :items="AreaCodeOptions" :rules="AreaCodeRules" v-model="AreaCode"
                dense clearable required outlined class="modern-input"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <div class="filter-label-wrapper">
                <v-icon small color="primary" class="mr-1">mdi-vector-polygon</v-icon>
                <label class="filter-label"><span class="text-danger">*</span> Zone</label>
              </div>
              <v-autocomplete :reduce="(option) => option.value" :loading="ZoneCodeOptionsLoading"
                :items="ZoneCodeOptions" :rules="ZoneCodeRules" v-model="ZoneCode" dense clearable required outlined
                class="modern-input"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" v-if="RegionFlag">
              <div class="filter-label-wrapper">
                <v-icon small color="primary" class="mr-1">mdi-domain</v-icon>
                <label class="filter-label">Region <small>(Optional)</small></label>
              </div>
              <v-autocomplete @change="getLomCodeOptions" :reduce="(option) => option.value"
                :loading="RegionCodeOptionsLoading" :items="RegionCodeOptions" :rules="RegionCodeRules"
                v-model="RegionCode" dense clearable required outlined class="modern-input"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" v-if="LoFlag">
              <div class="filter-label-wrapper">
                <v-icon small color="primary" class="mr-1">mdi-office-building</v-icon>
                <label class="filter-label">LO <small>(Optional)</small></label>
              </div>
              <v-autocomplete :reduce="(option) => option.value" :loading="LomCodeOptionsLoading"
                :items="LomCodeOptions" v-model="LomCode" dense clearable required outlined
                class="modern-input"></v-autocomplete>
            </v-col>
          </v-row>

          <!-- Action Buttons -->
          <v-row wrap class="mt-4">
            <v-col align="center" cols="12">
              <v-btn :disabled="!valid1" @click.prevent="searchForm" :loading="SearchFlag" color="primary"
                class="modern-search-btn px-8 py-3 mr-3" elevation="4">
                <v-icon left>mdi-magnify</v-icon>
                Search
              </v-btn>
              <v-btn @click.prevent="resetForm" color="secondary" class="modern-reset-btn px-8 py-3 mr-3" elevation="4">
                <v-icon left>mdi-refresh</v-icon>
                Reset
              </v-btn>
              <v-btn v-if="RoleId == 2" @click.prevent="updateMemberZone" :loading="UpdateZoneStatusFlag"
                color="warning" dark class="modern-update-btn px-8 py-3 mr-3" elevation="4">
                <v-icon left>mdi-map-marker-check</v-icon>
                Update Member Zone
              </v-btn>
              <v-btn v-if="RoleId == 2" @click.prevent="updateMemberLoStatus" :loading="UpdateLoStatusFlag"
                color="success" class="modern-update-btn px-8 py-3" elevation="4">
                <v-icon left>mdi-update</v-icon>
                Update Member LO Status
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Skeleton Loading -->
    <v-container class="py-0" v-if="StartupLoadingFlag">
      <v-skeleton-loader v-bind="attrs" type="table-tbody"></v-skeleton-loader>
    </v-container>

    <!-- Empty State -->
    <v-container class="py-0" v-if="tableData1.length <= 0 && !StartupLoadingFlag">
      <v-card elevation="4" class="empty-state-card">
        <v-card-text class="text-center py-16">
          <v-icon size="80" color="rgba(0,0,0,0.2)" class="mb-4">mdi-inbox-multiple</v-icon>
          <h3 class="text-h5 mt-4 text-secondary">No Records Found</h3>
          <p class="text-body2 text-grey mt-2">Please select filters and click Search to view records.</p>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Data Table -->
    <v-container class="py-0" v-if="tableData1.length > 0">
      <v-card elevation="8" class="data-table-card">
        <v-card-text class="pa-6">
          <div class="d-flex justify-space-between align-center mb-4">
            <h3 class="text-h6 font-weight-bold d-flex align-center">
              <v-icon left color="primary">mdi-table</v-icon>
              <span>{{ tableData1.length }} Members Found</span>
            </h3>
            <v-text-field v-model="search1" prepend-inner-icon="mdi-magnify" label="Search records" single-line outlined
              dense hide-details class="search-field" style="max-width: 300px"></v-text-field>
          </div>

          <div class="table-wrapper">
            <v-data-table class="modern-data-table" :search="search1" :item-key="tableOptions1.ItemKey"
              :single-select="tableOptions1.SingleSelectFlag" :headers="tableColumns1" :items="tableData1"
              :items-per-page="tableOptions1.ItemsPerPage" :footer-props="tableOptions1.FooterProps">
              <template #body="{ items, headers }">
                <tbody>
                  <tr v-for="item in items" :key="item.MemberId">
                    <td v-for="header in headers" :key="header.value">
                      <div v-if="header.value === 'ProfilePic'" class="profile-pic-wrapper">
                        <img :src="item[header.value]" class="profile-pic" />
                      </div>
                      <v-chip v-else-if="header.value === 'LomStatusColor'" :color="item[header.value] || 'primary'"
                        text-color="white" small label>
                        {{ item[header.value] === 'red' ? 'Disaffiliated' : 'Active' }}
                      </v-chip>
                      <span v-else-if="header.value === 'LomName'"
                        :class="{ 'lom-name-red': item.LomStatusColor === 'red' }">{{ item[header.value] }}</span>
                      <span v-else>{{ item[header.value] }}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-container>

    <div class="page-footer"></div>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import LomTrainingApproval from "@/view/pages/erp/ldmt/LomTrainingApproval.vue";

export default {
  mixins: [common],
  components: { LomTrainingApproval },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      FloatingButtonFlag: false,
      SearchFlag: false,
      UpdateLoStatusFlag: false,
      UpdateZoneStatusFlag: false,
      SubmitFlag: false,
      ResultFlag: false,

      TrainingData1: {},

      rows: [],
      tableColumns1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      AreaFlag: false,
      RegionFlag: false,
      LoFlag: false,

      selectedData: {},
      RoleId: "",
      TableDisplayFlag1: false,

      zone: {},
      lom: {},

      name: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,

      JciYearCode: "",

      JciYearCodeFlag: false,
      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCode: "",
      JciYearCodeOptions: [],

      AreaCodeRules: [(v) => !!v || "Area is required"],
      AreaCode: "",
      AreaCodeOptions: [],
      AreaCodeOptionsLoading: false,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      RegionCodeRules: [],
      RegionCode: "",
      RegionCodeOptions: [],
      RegionCodeOptionsLoading: false,

      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      search1: "",
      selected1: "",
      tableColumns1: [],
      tableData1: [],
      tableOptions1: {},

      tableColumns2: [],
      tableData2: [],
      tableOptions2: {},

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",

      DownloadFlag: false,
      ExcelFileName: "",
      ExcelFields: {},
    };
  },
  mounted() {
    /*
        this.$store.dispatch(SET_BREADCRUMB, [
          { title: "Vuetify", route: "alerts" },
          { title: "Form Inputs & Control", route: "autocompletes" },
          { title: "Fileinptus" },
        ]);
        */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;


        this.CurrentYearId = CurrentJciYearId;
        this.getJciYearCodeOptions();

        this.pageData();
        this.getZoneCodeOptions();
      }
    },
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
    AreaCodeOptions: function () {
      console.log("watch AreaCodeOptions");
      this.AreaCodeOptionsLoading = false;
      this.LoadingFlag = false;
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.ZoneCodeOptionsLoading = false;
    },
    RegionCodeOptions: function () {
      console.log("watch RegionCodeOptions");
      this.RegionCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LomCodeOptionsLoading = false;
    },
    JciYearCode: function () {
      console.log("Watch JciYearCode called");
      this.resetFrom();
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jac_report",
        Action: "report_2",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getAreaCodeOptions();
    },
    backPage() {
      this.$router.go(-1);
    },
    resetForm() {
      this.search = "";
      this.tableData2 = [];
      this.tableData1 = [];
      this.selected = [];
      this.$refs.form2.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    getJciYearCodeOptions() {
      console.log("getJciYearCodeOptions called");
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        LomCode: 3,
        ZoneCode: 2,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getAreaCodeOptions() {
      console.log("getAreaCodeOptions called");
      this.AreaCodeOptionsLoading = true;
      var selectbox1_source = "AreaCode";
      var selectbox1_destination = "AreaCodeOptions";
      var selectbox1_url = "api/year-wise-lom/area-options";
      var selectbox1_conditions_array = {
        UserInterface: 4,
        YearCode: this.JciYearCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      this.LomCodeOptions = [];
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.ZoneCode = "";
        this.ZoneCodeOptionsLoading = true;
        this.tableData2 = [];
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: this.JciYearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getRegionCodeOptions() {
      console.log("getRegionCodeOptions called");
      var YearCode = this.JciYearCode;
      var AreaCode = this.AreaCode;
      var ZoneCode = this.ZoneCode;
      this.RegionCodeOptions = [];
      this.LomCodeOptions = [];
      console.log(
        "YearCode=" +
        YearCode +
        ", AreaCode=" +
        AreaCode +
        ", ZoneCode=" +
        ZoneCode
      );
      if (YearCode != "" && AreaCode != "" && ZoneCode != "") {
        this.RegionCode = "";
        this.RegionCodeOptionsLoading = true;
        this.tableData2 = [];
        var selectbox1_source = "RegionCode";
        var selectbox1_destination = "RegionCodeOptions";
        var selectbox1_url = "api/year-wise-lom/region-options";
        var selectbox1_conditions_array = {
          UserInterface: 4,
          YearCode: YearCode,
          AreaCode: AreaCode,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      this.tableData1 = [];
      this.LomCode = "";
      this.LomCodeOptions = [];

      var YearCode = this.JciYearCode;
      var ZoneCode = this.ZoneCode;
      var RegionCode = this.RegionCode;
      console.log(
        "YearCode=" +
        YearCode +
        ", ZoneCode=" +
        ZoneCode +
        ", RegionCode=" +
        RegionCode
      );
      if (YearCode != "" && ZoneCode != "" && RegionCode != "") {
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 3,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
          RegionCode: RegionCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        if (RegionCode == "") {
          message += "Region should not be empty. ";
        }
        this.alert = {
          flag: true,
          color: "error",
          message: message,
        };
      }
    },
    searchForm() {
      console.log("searchForm called");

      var validate1 = this.$refs.form2.validate();
      console.log("validate1=" + validate1);

      if (validate1) {
        this.TrainingData = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/senior-members/membership-report";
        var upload = {
          UserInterface: 1,
          Area: this.AreaCode,
          Year: this.JciYearCode,
          Zone: this.ZoneCode,
          Lom: this.LomCode,
          Region: this.RegionCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.tableData1 = [];
        this.LoadingFlag = true;
        this.SearchFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            var options = records.TableOptions;
            thisIns.tableOptions1 = options;

            if (flag == 1) {
              thisIns.tableColumns1 = records.TableHeader;
              thisIns.tableData1 = records.TableData;
              thisIns.TrainingData1 = records.ImportantLavDates;

              thisIns.DownloadFlag = options.DownloadFlag;
              thisIns.ExcelFileName = options.ExcelFileName;
              thisIns.ExcelFields = options.ExcelFields;

              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Kindly fill required fields.";
        this.toast("error", message);
      }
    },
    updateMemberLoStatus() {
      console.log("updateMemberLoStatus called");

      var validate1 = true;
      if (validate1) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url =
          server_url + "api/senior-member-report/update-member-lo-status";
        var upload = {
          UserInterface: 1,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.UpdateLoStatusFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.UpdateLoStatusFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.toast("success", output);
              // Refresh the table after successful update
              thisIns.searchForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.UpdateLoStatusFlag = false;
          });
      }
    },
    updateMemberZone() {
      console.log("updateMemberZone called");

      var validate1 = true;
      if (validate1) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url =
          server_url + "api/senior-member-report/update-member-zone";
        var upload = {
          UserInterface: 1,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
          server_url +
          ", token=" +
          token +
          ", add_url=" +
          add_url
        );

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.UpdateZoneStatusFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.UpdateZoneStatusFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.toast("success", output);
              // Refresh the table after successful update
              thisIns.searchForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.UpdateZoneStatusFlag = false;
          });
      }
    }
  },
  beforeMount() {
    this.refreshPageData();
    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? "" : RoleId;
    console.log({ RoleId });
    this.RoleId = RoleId;

    this.tableColumns1.push(
      { text: "Photo", value: "ProfilePic" },
      { text: "Zone", value: "ZoneName" },
      { text: "LO Name", value: "LomName" },
      { text: "Status", value: "LomStatusColor" },
      { text: "Membership Id", value: "MembershipId" },
      { text: "Member Name", value: "MemberName" },
      { text: "Mobile No", value: "MobileNo" },
      { text: "Email", value: "EmailId" },
      { text: "Address", value: "AddressTxt" },
      { text: "Previous Year JAC", value: "PreviousSMAPaidCount" },
      { text: "Current Year JAC", value: "CurrentSMAPaidCount" }
    );
  }
};
</script>

<style lang="scss" scoped>
// Color Palette (JCI Approved Colors)
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$seaform: #56bda3;
$text-90-black: #414042;
$text-off-black: #0a0f29;
$text-white: #ffffff;

$primary-color: $navy;
$secondary-color: $aqua;
$success-color: $seaform;
$warning-color: $gold;
$danger-color: #e74c3c;
$info-color: $aqua;
$light-bg: #f8fafc;
$bg-light: #f1f5f9;
$text-primary: $text-off-black;
$text-secondary: $text-90-black;
$border-color: #e2e8f0;
$gradient-main: linear-gradient(135deg, $navy 0%, $aqua 100%);

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-12px);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

#senior-member-report-page {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 32px 16px;
  position: relative;

  // ============================================
  // HEADER CARD - EFFICIENCY LOM STATUS STYLE
  // ============================================
  .header-card {
    background: linear-gradient(135deg, $navy 0%, $aqua 50%, $navy 100%) !important;
    border-radius: 20px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5),
      0 0 40px rgba(0, 151, 215, 0.3);

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
      animation: shimmer 3s infinite;
    }

    .header-gradient {
      position: relative;
      z-index: 1;
    }

    .header-backdrop-effect {
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%);
      animation: rotate 25s linear infinite;
    }

    .header-content {
      position: relative;
      z-index: 2;
    }

    .action-btn {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      font-weight: 700;
      background: rgba(255, 255, 255, 0.15) !important;
      border: 2px solid rgba(255, 255, 255, 0.3) !important;
      backdrop-filter: blur(10px);
      color: white !important;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3) !important;
        background: rgba(255, 255, 255, 0.25) !important;
      }
    }
  }

  .header-container {
    padding: 20px 0 !important;
  }

  .header-icon-box {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%);
    backdrop-filter: blur(15px);
    border-radius: 18px;
    padding: 14px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.4);
    animation: float 4s ease-in-out infinite;
    border: 2px solid rgba(255, 255, 255, 0.3);
  }

  .header-title {
    font-size: 36px;
    font-weight: 900;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 151, 215, 0.3);
    animation: slideInLeft 0.8s ease-out;
    letter-spacing: 0.8px;
    color: $text-white;
    margin: 0;
  }

  .header-subtitle {
    font-size: 17px;
    opacity: 0.98;
    animation: slideInLeft 1s ease-out 0.1s backwards;
    letter-spacing: 0.4px;
    color: $text-white;
    font-weight: 500;
    margin: 8px 0 0 0;
  }

  .title-content {
    animation: slideInLeft 0.8s ease-out 0.1s backwards;
  }

  .action-buttons-group {
    display: flex;
    gap: 12px;
    animation: slideInRight 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  .modern-action-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    color: white !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

    &:hover {
      background: rgba(255, 255, 255, 0.25) !important;
      box-shadow: 0 12px 36px rgba(0, 0, 0, 0.25);
      transform: translateY(-2px);
    }

    &.refresh-btn {
      &:hover {
        animation: rotate 1s linear infinite;
      }
    }
  }

  // ============================================
  // FILTER CARD
  // ============================================
  .filter-card {
    border-radius: 16px !important;
    border: none !important;
    background: white !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    animation: fadeInScale 0.6s ease-out 0.2s backwards;

    .filter-label-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }

    .filter-label {
      font-size: 14px;
      font-weight: 600;
      color: $text-primary;
      margin: 0;
    }

    .modern-input {
      border-radius: 8px !important;
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 4px 12px rgba(58, 103, 177, 0.1);
      }

      &:focus-within {
        box-shadow: 0 4px 16px rgba(58, 103, 177, 0.2);
      }
    }

    .modern-search-btn {
      background: linear-gradient(135deg, $primary-color 0%, $secondary-color 100%) !important;
      color: white !important;
      font-weight: 600;
      letter-spacing: 0.5px;
      transition: all 0.3s ease;
      border-radius: 8px;

      &:hover {
        box-shadow: 0 8px 24px rgba(58, 103, 177, 0.4);
        transform: translateY(-2px);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    .modern-reset-btn {
      background: #6c757d !important;
      color: white !important;
      font-weight: 600;
      letter-spacing: 0.5px;
      transition: all 0.3s ease;
      border-radius: 8px;

      &:hover {
        box-shadow: 0 8px 24px rgba(108, 117, 125, 0.4);
        transform: translateY(-2px);
      }
    }

    .modern-update-btn {
      background: linear-gradient(135deg, $success-color 0%, #2cc4a0 100%) !important;
      color: white !important;
      font-weight: 600;
      letter-spacing: 0.5px;
      transition: all 0.3s ease;
      border-radius: 8px;

      &:hover {
        box-shadow: 0 8px 24px rgba(86, 189, 163, 0.4);
        transform: translateY(-2px);
      }
    }
  }

  // ============================================
  // EMPTY STATE
  // ============================================
  .empty-state-card {
    border-radius: 16px !important;
    border: none !important;
    background: linear-gradient(135deg, #f9f9f9 0%, #f0f0f0 100%) !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.05);
    animation: fadeInScale 0.6s ease-out;
  }

  // ============================================
  // DATA TABLE CARD
  // ============================================
  .data-table-card {
    border-radius: 16px !important;
    border: none !important;
    background: white !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    animation: fadeInScale 0.6s ease-out 0.2s backwards;
    overflow: hidden;
  }

  .table-wrapper {
    border-radius: 12px;
    overflow: auto;
    background: white;

    .modern-data-table {
      border-collapse: collapse;

      thead {
        background: linear-gradient(135deg, $navy 0%, $aqua 100%);
        color: white;

        th {
          font-weight: 700 !important;
          letter-spacing: 0.5px;
          padding: 16px 12px !important;
          font-size: 13px;
          text-transform: uppercase;
          border: none !important;
          box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.1);
        }
      }

      tbody {
        tr {
          transition: all 0.3s ease;
          border-bottom: 1px solid $border-color;

          &:hover {
            background-color: rgba(58, 103, 177, 0.05);
          }

          &.disaffiliated-row {
            background-color: rgba(244, 67, 54, 0.08);

            &:hover {
              background-color: rgba(244, 67, 54, 0.12);
            }

            .disaffiliated-cell {
              color: #d32f2f;
              font-weight: 600;
            }
          }

          td {
            padding: 14px 12px !important;
            font-size: 14px;
            border: none !important;
            color: $text-secondary;

            .profile-pic-wrapper {
              display: flex;
              justify-content: center;
              align-items: center;

              .profile-pic {
                width: 90px;
                height: 90px;
                border-radius: 12px;
                border: 3px solid $border-color;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                transition: all 0.3s ease;
                object-fit: cover;

                &:hover {
                  box-shadow: 0 8px 20px rgba(58, 103, 177, 0.2);
                  transform: scale(1.08);
                }
              }
            }
          }
        }
      }
    }
  }

  .search-field {
    max-width: 350px !important;

    ::v-deep {
      .v-input__prepend-inner {
        margin-right: 12px;
      }

      input {
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  // ============================================
  // PAGE CONTENT & FOOTER
  // ============================================
  .page-content {
    padding: 0 !important;
  }

  .page-footer {
    height: 40px;
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 1200px) {
    .header-title {
      font-size: 32px;
    }

    .header-subtitle {
      font-size: 15px;
    }
  }

  @media (max-width: 960px) {
    padding: 20px 12px;

    .header-card {
      .d-flex {
        flex-direction: column;
        gap: 20px;
      }

      .action-buttons-group {
        width: 100%;
        justify-content: flex-start;
      }
    }

    .header-title {
      font-size: 28px;
    }

    .header-subtitle {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    padding: 16px 8px;

    .header-card {
      border-radius: 16px;
    }

    .filter-card {
      border-radius: 12px;
    }

    .data-table-card {
      border-radius: 12px;
    }

    .header-icon-box {
      padding: 10px;
    }

    .header-title {
      font-size: 24px;
    }

    .header-subtitle {
      font-size: 13px;
    }

    .modern-data-table {
      font-size: 12px !important;

      thead th {
        padding: 12px 8px !important;
        font-size: 11px;
      }

      tbody td {
        padding: 10px 8px !important;
        font-size: 12px;
      }

      .profile-pic {
        width: 48px;
        height: 48px;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 12px 6px;

    .header-title {
      font-size: 20px;
    }

    .header-subtitle {
      font-size: 12px;
    }

    .modern-action-btn {
      padding: 8px !important;
    }
  }
}

// Utility classes
.gap-4 {
  gap: 16px;
}

.d-flex {
  display: flex;
}

.justify-space-between {
  justify-content: space-between;
}

.justify-center {
  justify-content: center;
}

.align-center {
  align-items: center;
}

.overflow-hidden {
  overflow: hidden;
}

.mb-4 {
  margin-bottom: 16px;
}

.mb-6 {
  margin-bottom: 24px;
}

.pa-6 {
  padding: 24px;
}

.px-8 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-6 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.text-h6 {
  font-size: 20px;
  font-weight: 600;
}

.font-weight-bold {
  font-weight: 700;
}

.text-danger {
  color: #d32f2f;
}

.text-secondary {
  color: $text-secondary;
}

.text-grey {
  color: #999;
}

.py-16 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.mt-4 {
  margin-top: 16px;
}

.mr-1 {
  margin-right: 4px;
}

.mr-3 {
  margin-right: 12px;
}

// LOM name red color when status is 4
.lom-name-red {
  color: #d32f2f !important;
  font-weight: 700 !important;
}
</style>

<style lang="scss">
// Global styles for dialogs and overlays (non-scoped)</style>